import useMediaQuery from '@utility/hooks/useMediaQuery';
import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

const PageTitleAnimationHandler = () => {
  const isMobile = useMediaQuery(1408);
  const [pageRoot, setPageRoot] = useState<HTMLElement>();
  const [sectionElements, setSectionElements] = useState<
    NodeListOf<Element> | []
  >([]);

  useEffect(() => {
    const pageRoot = document.getElementById('colour-background');
    if (!pageRoot) return;

    setPageRoot(pageRoot);

    const elementsWithBackground = document.querySelectorAll(
      'section[data-background-color]',
    );

    setSectionElements(elementsWithBackground);
  }, []);

  const handleBackgroundChange = () => {
    let mostVisibleBackgroundColour = '';

    sectionElements.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const isPageTitle = section.getAttribute('data-is-page-title');
      const animationTopOffset = isMobile ? -50 : 175;

      const pageTitleAnimationCondition = isMobile
        ? rect.top - animationTopOffset < rect.height &&
          rect.bottom > rect.height / 2
        : rect.top < animationTopOffset && rect.bottom > rect.height / 2;

      const componentInView = !!isPageTitle
        ? pageTitleAnimationCondition
        : Math.abs(rect.top) < rect.height;

      if (componentInView) {
        mostVisibleBackgroundColour =
          section.getAttribute('data-background-color') || '';
      }
    });

    requestAnimationFrame(() => {
      if (pageRoot!.style.backgroundColor !== mostVisibleBackgroundColour) {
        pageRoot!.style.backgroundColor = mostVisibleBackgroundColour ?? '';
      }
    });
  };

  const throttledHandleBackgroundChange = throttle(
    handleBackgroundChange,
    isMobile ? 300 : 100,
  );

  useEffect(() => {
    if (!sectionElements || !pageRoot) return;

    handleBackgroundChange();

    window.addEventListener('scroll', throttledHandleBackgroundChange, {
      passive: true,
    });

    window.addEventListener('resize', throttledHandleBackgroundChange, {
      passive: true,
    });

    return () => {
      throttledHandleBackgroundChange.cancel();
      window.removeEventListener('scroll', throttledHandleBackgroundChange);
      window.removeEventListener('resize', throttledHandleBackgroundChange);
    };
  }, [isMobile, pageRoot, sectionElements]);

  return null;
};

export default PageTitleAnimationHandler;
